/* eslint-disable import/no-mutable-exports */
import {Store} from '@reduxjs/toolkit'

import {RootState} from './configureStore'

type StoreType = Store<RootState, any>

let store: StoreType

function setStore(newStore: StoreType) {
  store = newStore
}

export {setStore, store}
